import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatText'
})
export class FormatTextPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Échappe les balises HTML potentielles pour éviter les injections
    const escapedText = value
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    // Remplace les retours à la ligne par des balises HTML <br>
    const withLineBreaks = escapedText.replace(/\n/g, '<br>');

    // Gère les espaces multiples (transforme en espaces insécables)
    const withSpaces = withLineBreaks.replace(/ {2,}/g, match => {
      return match.split('').map(() => '&nbsp;').join('');
    });

    return withSpaces;
  }
}

